import { ExpandMore } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import React, { useRef, useState } from "react";

export default function ClosedOrderItemRow({ entry }) {
    const [open, setOpen] = useState(false);
    const hasAddons = Array.isArray(entry?.addons) && entry.addons.length > 0;
    const img = entry?.cover;
    const pointerState = useRef({
        x: 0,
        y: 0,
        moved: false,
        active: false,
    });

    return (
        <div
            style={{
                background: "#fff",
                border: "1px solid #e5e9f2",
                borderRadius: 12,
                padding: "0.75rem",
                marginBottom: "0.5rem",
                cursor: hasAddons ? "pointer" : "default",
            }}
            onPointerDown={(e) => {
                if (!hasAddons) return;
                pointerState.current = {
                    x: e.clientX,
                    y: e.clientY,
                    moved: false,
                    active: true,
                };
            }}
            onPointerMove={(e) => {
                if (!hasAddons) return;
                if (!pointerState.current.active) return;
                const dx = Math.abs(e.clientX - pointerState.current.x);
                const dy = Math.abs(e.clientY - pointerState.current.y);
                if (dx > 6 || dy > 6) {
                    pointerState.current.moved = true;
                }
            }}
            onPointerUp={() => {
                if (!hasAddons) return;
                const { moved, active } = pointerState.current;
                pointerState.current.active = false;
                if (active && !moved) {
                    setOpen((v) => !v);
                }
            }}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "0.75rem",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.75rem",
                        minWidth: 0,
                    }}
                >
                    <div
                        style={{
                            width: 44,
                            height: 44,
                            borderRadius: 10,
                            overflow: "hidden",
                            background: "#f1f3f8",
                            flex: "0 0 auto",
                        }}
                    >
                        {img ? (
                            <img
                                src={img}
                                alt=""
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                }}
                                draggable={false}
                            />
                        ) : null}
                    </div>
                    <div style={{ minWidth: 0 }}>
                        <div
                            style={{
                                fontWeight: 900,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {entry?.item_name || entry?.item_code}
                        </div>
                        <div
                            style={{
                                color: "#6E7187",
                                fontWeight: 800,
                                fontSize: 12,
                            }}
                        >
                            {entry?.item_code} • x {entry?.qty || 0}
                        </div>
                    </div>
                </div>

                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.25rem",
                    }}
                >
                    <div style={{ fontWeight: 900 }}>
                        {Number.isFinite(entry?.amount) ? entry.amount : 0}
                    </div>
                    {hasAddons ? (
                        <IconButton
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                setOpen((v) => !v);
                            }}
                            aria-label="Toggle addons"
                        >
                            <ExpandMore
                                style={{
                                    transform: open
                                        ? "rotate(180deg)"
                                        : "rotate(0deg)",
                                    transition: "transform 120ms ease",
                                }}
                            />
                        </IconButton>
                    ) : null}
                </div>
            </div>

            {/* Notes (always visible when present) */}
            {entry?.notes ? (
                <div
                    style={{
                        marginTop: "0.5rem",
                        background: "rgba(251, 253, 245, 0.75)",
                        border: "1px solid #e5e9f2",
                        borderRadius: 10,
                        padding: "0.6rem",
                        fontWeight: 700,
                        whiteSpace: "pre-wrap",
                    }}
                >
                    {entry.notes}
                </div>
            ) : null}

            {/* Addons */}
            {hasAddons && open ? (
                <div style={{ marginTop: "0.6rem", paddingLeft: "0.5rem" }}>
                    {entry.addons.map((ad) => (
                        <div
                            key={ad.id}
                            style={{
                                borderLeft: "3px solid #e5e9f2",
                                paddingLeft: "0.75rem",
                                marginBottom: "0.5rem",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: "0.75rem",
                                }}
                            >
                                <div style={{ fontWeight: 900 }}>
                                    {ad.item_name || ad.item_code}
                                </div>
                                <div style={{ fontWeight: 900 }}>
                                    {Number.isFinite(ad.amount) ? ad.amount : 0}
                                </div>
                            </div>
                            <div
                                style={{
                                    color: "#6E7187",
                                    fontWeight: 800,
                                    fontSize: 12,
                                }}
                            >
                                {ad.item_code} • x {ad.qty || 0}
                            </div>
                            {ad.notes ? (
                                <div
                                    style={{
                                        marginTop: "0.35rem",
                                        background: "rgba(251, 253, 245, 0.75)",
                                        border: "1px solid #e5e9f2",
                                        borderRadius: 10,
                                        padding: "0.5rem",
                                        fontWeight: 700,
                                        whiteSpace: "pre-wrap",
                                    }}
                                >
                                    {ad.notes}
                                </div>
                            ) : null}
                        </div>
                    ))}
                </div>
            ) : null}
        </div>
    );
}


